import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import News from '@/views/newsViewList.vue'
import NewDetail from '@/views/newDetail.vue'
import AboutView  from '@/views/AboutView.vue'
import productsView  from '@/views/productsView.vue'
import productDetail  from '@/views/products/productDetail.vue'
import technologyView from '@/views/technologyView.vue' 
import projectView from '@/views/projectView.vue' 
import  contactUs from '@/views/ContactUs.vue' 
import  developmentHistory from '@/views/developmentHistory.vue' 

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component:AboutView
  }  ,
  {
    path: '/news',
    name: 'News',
    component: News,
  },
    {
    path: '/newDetail',
    name: 'NewDetail',
    component: NewDetail,
  }, {
    path: '/news',
    name: 'News',
    component: News,
  },
  {
  path: '/products',
  name: 'products',
  component: productsView,
  },
  {
  path: '/productDetail',
  name: 'productDetail',
  component: productDetail,
  },
  {
    path: '/technologyView',
    name: 'technologyView',
    component: technologyView,
  },
  {
    path: '/projectView',
    name: 'projectView',
    component: projectView,
  },
  {
    path: '/projectView',
    name: 'projectView',
    component: projectView,
  }
  ,
  {
    path: '/contactUs',
    name: 'contactUs',
    component: contactUs,
  },
  {
    path: '/developmentHistory',
    name: 'developmentHistory',
    component: developmentHistory,
  },
  {
    path: '/shenghuo',
    name: 'shenghuo',
    component: () => import('@/views/renliziyuan/shenghuoView.vue'),
    meta: { zh: '生活在太药', en: 'Talent Philosophy' }
  },
  {
    path: '/talent-philosophy',
    name: 'TalentPhilosophy',
    component: () => import('@/views/renliziyuan/TalentPhilosophy.vue'),
    meta: { zh: '人才理念', en: 'Talent Philosophy' }
  },
  {
    path: '/learnerBeliefView',
    name: 'learnerBeliefView',
    component: () => import('@/views/renliziyuan/learnerBeliefView.vue'),
    meta: { zh: '学习理念', en: 'Talent Philosophy' }
  },
  {
    path: '/‌socialRecruitment',
    name: '‌socialRecruitment‌',
    component: () => import('@/views/renliziyuan/‌socialRecruitment‌.vue'),
    meta: { zh: '社会招聘', en: 'Learning Philosophy' }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
